<nav class="main-nav">
  <section class="">
    <ng-container *ngFor="let section of mainMenuConfig$ | async">
      <section
        class="nav-group"
        [attr.data-section-id]="section.id"
        [class.collapsible]="section.collapsible"
        [class.collapsed]="
          section.collapsible && !expandedSections.includes(section.id)
        "
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: isDashboardSection(section) }"
        (isActiveChange)="setExpanded(section, $event)"
        *ngIf="shouldDisplayLink(section)"
      >
        <vdr-ui-extension-point
          [locationId]="section.id"
          api="navMenu"
          [topPx]="0"
          [leftPx]="8"
          display="block"
        >
          <div
            class="section-header cursor-pointer select-none"
            (click)="section.collapsible && toggleExpand(section)"
          >
            <ng-container
              *ngIf="
                navBuilderService.sectionBadges[section.id]
                  | async as sectionBadge
              "
            >
              <vdr-status-badge
                *ngIf="sectionBadge !== 'none'"
                [type]="sectionBadge"
              ></vdr-status-badge>
            </ng-container>
            <label
              [ngClass]="{ 'nav-group-collapse': section.collapsible }"
              *ngIf="section.label"
              class="nav-group-header mx-3"
              [for]="section.id"
            >
              <vdr-icon *ngIf="section.icon" [name]="section.icon"></vdr-icon>
              <span>{{ section.label | translate }}</span>
            </label>
            <div
              *ngIf="section.collapsible"
              class="btn-expand"
              [ngClass]="
                expandedSections.includes(section.id) && 'active-group-icon'
              "
            >
              <img
                class="arrow-down"
                src="assets/icons/icn-chevron-down.svg"
                alt="icn-chevron-down"
              />
            </div>
          </div>
          <div class="nav-list" [ngStyle]="getStyleForSection(section)">
            <ng-container *ngFor="let item of section.items">
              <a
                [attr.data-item-id]="section.id"
                [routerLink]="getRouterLink(item)"
                (click)="onItemClick(item, $event)"
                class="nav-link px-3 py-1 gap-2 hover:text-current"
                [ngClass]="{
                  only: section.items.length <= 1,
                  disabled: item.disabled
                }"
                *ngIf="shouldDisplayLink(item)"
                [class.active]="item === activeItem"
              >
                <ng-container *ngIf="item.statusBadge | async as itemBadge">
                  <vdr-status-badge
                    *ngIf="itemBadge.type !== 'none'"
                    [type]="itemBadge.type"
                  ></vdr-status-badge>
                </ng-container>
                <vdr-icon *ngIf="item.icon" [name]="item.icon"></vdr-icon>
                <span>{{ item.label | translate }}</span>
              </a>
            </ng-container>
          </div>
        </vdr-ui-extension-point>
      </section>
    </ng-container>
  </section>

  <!-- Contact Info Widget -->
  <div class="mx-3 my-4 p-3 rounded-lg border" style="background-color: var(--color-page-header-item-bg); border-color: var(--color-weight-200);">
    <div class="text-xs font-semibold uppercase tracking-wider" style="color: var(--color-grey-600);">{{ 'nav.contact-support' | translate }}</div>
    <div class="flex flex-col gap-2 mt-2">
      <div class="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width: 18px; height: 18px; min-width: 18px; color: var(--color-primary-600);">
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.387a12.035 12.035 0 0 1-7.108-7.108c-.155-.44.011-.927.387-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
        </svg>
        <a href="tel:0904714141" class="text-sm font-bold hover:underline" style="color: var(--color-primary-600);">090 471 4141</a>
      </div>
      <div class="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width: 18px; height: 18px; min-width: 18px; color: var(--color-primary-600);">
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.387a12.035 12.035 0 0 1-7.108-7.108c-.155-.44.011-.927.387-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
        </svg>
        <a href="tel:0706797328" class="text-sm font-bold hover:underline" style="color: var(--color-primary-600);">070 679 7328</a>
      </div>
    </div>
  </div>
  <!-- <div class="flex justify-center p-2 relative">
    <img src="assets/img/sidebar-policy-bg.png" alt="logo" class="w-full" />

    <div
      class="absolute p-6 inset-0 flex flex-col justify-center items-center gap-3"
    >
      <h3 class="text-white font-bold shadow-2xl text-lg">Escape Room</h3>
      <p class="text-center text-white">
        Tham khảo chính sách mới của Escape Room
      </p>
      <button class="btn bg-white text-primary rounded-lg py-1 font-medium">
        Tham khảo
      </button>
    </div>
  </div> -->
</nav>
